import axios from "axios";
import store from "../redux/store";
import { SERVER_URL } from "../config/index";

const request = axios.create({
  baseURL: SERVER_URL,
  timeout: 1000000,
});
request.interceptors.request.use(
  (config) => {
    if (store.getState().user?.token) {
      config.headers.Authorization = `Bearer ${store.getState().user?.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/* Auth API */
// Login
export const adminLogin = (data) => {
  return axios.post(SERVER_URL + "auth/login", data).then((res) => res.data);
};

// Profile
export const getProfile = () => {
  return request.get("auth/profile").then((res) => res.data);
};

// Change Password
export const changePassword = (data) => {
  return request.put("auth/change-password", data).then((res) => res.data);
};

/* Site Settings API */
// Get Settings
export const getSettings = () => {
  return request.get("settings").then((res) => res.data);
};

// Update Settings
export const updateSettings = (data) => {
  return request.put("settings", data).then((res) => res.data);
};

/* Services API */
// Get Service List
export const getServiceList = (params) => {
  return request.get("service", { params }).then((res) => res.data);
};

// Get Service By Id
export const getServiceById = (id) => {
  return request.get(`service/${id}`).then((res) => res.data);
};

// Add Service
export const addService = (data) => {
  return request.post("service", data).then((res) => res.data);
};

// Update Service By Id
export const editServiceById = (id, data) => {
  return request.put(`service/${id}`, data).then((res) => res.data);
};

// Delete Service By Id
export const deleteServiceById = (id) => {
  return request.delete(`service/${id}`).then((res) => res.data);
};

/* Blogs API */
// Get Blog List
export const getBlogList = (params) => {
  return request.get("blog", { params }).then((res) => res.data);
};

// Get Blog By Id
export const getBlogById = (id) => {
  return request.get(`blog/${id}`).then((res) => res.data);
};

// Add Blog
export const addBlog = (data) => {
  return request.post("blog", data).then((res) => res.data);
};

// Update Blog By Id
export const editBlogById = (id, data) => {
  return request.put(`blog/${id}`, data).then((res) => res.data);
};

// Delete Blog By Id
export const deleteBlogById = (id) => {
  return request.delete(`blog/${id}`).then((res) => res.data);
};

/* Blog Categories API */
// Get Category List
export const getBlogCategories = (params) => {
  return request.get("blog-category", { params }).then((res) => res.data);
};

// Add Category
export const addBlogCategory = (data) => {
  return request.post("blog-category", data).then((res) => res.data);
};

// Edit Category By Id
export const editBlogCategoryById = (id, data) => {
  return request.put(`blog-category/${id}`, data).then((res) => res.data);
};

// Delete Category By Id (With safety check)
export const deleteBlogCategoryById = (id) => {
  return request.delete(`blog-category/${id}`).then((res) => res.data);
};

/* Leads API */
// Get Lead List
export const getLeadList = (params) => {
  return request.get("lead", { params }).then((res) => res.data);
};

// Get Lead By Id
export const getLeadById = (id) => {
  return request.get(`lead/${id}`).then((res) => res.data);
};

// Delete Lead By Id
export const deleteLeadById = (id) => {
  return request.delete(`lead/${id}`).then((res) => res.data);
};

// Get Dashboard Counts
export const getDashboardCounts = () => {
  return request.get("lead/counts").then((res) => res.data);
};
